/**
 * Created by Ivan on 20.01.2026
 */

const RiddlesExpeditionFeastRowView = cc.Scale9Sprite.extend({
    ctor: function (row, options) {
        options = options || {};

        this.id = row.id;
        this.row = row;
        this.options = options;

        options.prizes = options.prizes !== undefined ? options.prizes : true;
        options.badges = options.badges !== undefined ? options.badges : true;

        const styles = cleverapps.styles.RiddlesExpeditionFeastRowView;
        this.contentHeight = styles.content.height;

        this.clickableArea = options.clickableArea;

        const background = this.isPlayer() ? bundles.expeditionfeast_window.frames.row_you_png : bundles.expeditionfeast_window.frames.row_player_png;

        this._super(background, cleverapps.UI.getScale9Rect(background, cleverapps.UI.Scale9Rect.TwoPixelXY));

        if (this.isPlayer()) {
            this.createFrame();
        }

        this.updatePlace(row.data.place);

        const place = this.createPlace(row.data.place);
        const avatar = this.avatar = this.createAvatar();
        const name = this.name = this.createName();
        name.setAnchorPoint(0.5, 0.5);
        name.setAlignment(styles.name.position);

        const prize = this.createPrize();

        const score = this.scoreNode = this.createScore();

        cleverapps.tooltipManager.create(score, {
            text: Messages.get(this.options.scoreTooltip || "ResultTooltip"),
            location: cleverapps.UI.Tooltip.LOCATION_BELOW,
            clickableArea: this.clickableArea
        });

        const nameWrapper = this.nameWrapper = new cc.Node();
        nameWrapper.setAnchorPoint(0.5, 0.5);
        nameWrapper.addChild(name);
        this.content = new cleverapps.Layout([place, avatar, nameWrapper, prize, score].filter(Boolean), {
            direction: cleverapps.UI.HORIZONTAL,
            padding: styles.content.padding
        });

        if (options.mission && this.isPlayer() && cleverapps.config.debugMode) {
            cleverapps.UI.onClick(this, () => {
                options.mission.update(10);
            });
        }

        this.addChild(this.content);
        this.onResize();
        this.content.setAlignment(styles.content);
    },

    isPlayer: function () {
        return this.row.data.player;
    },

    onResize: function () {
        const styles = cleverapps.styles.RiddlesExpeditionFeastRowView;

        cleverapps.UI.fitToBox(this.avatar, {
            height: this.contentHeight,
            maxScale: 1
        });

        if (this.prizeNode) {
            cleverapps.UI.fitToBox(this.prizeNode, {
                width: styles.prize.width,
                height: this.contentHeight
            });
        }

        let width = this.options.width || styles.width;
        if (this.options.dynamicWidth) {
            width = Math.max(styles.minWidth, Math.min(width, cleverapps.resolution.getSceneSize().width - styles.scenePadding[cleverapps.resolution.mode] * 2));
        }

        this.setContentSize2(width, this.options.height || styles.height);
        if (this.bg) {
            this.bg.setContentSize2(width, styles.height);
        }

        if (this.frame) {
            this.frame.setContentSize2(width, this.options.height || styles.height);
            this.frame.setPosition(this.width / 2, this.height / 2);
            this.frame.setAnchorPoint(0.5, 0.5);
        }
        const margin = styles.content.margin;
        const padding = styles.content.padding;

        const paddingX = padding.left[cleverapps.resolution.mode] + padding.right[cleverapps.resolution.mode];
        const nameWidth = width - paddingX - [this.placeNode, this.avatar, this.prizeNode, this.scoreNode].filter(Boolean).reduce((width, item) => width + item.width * item.scaleX + margin, 0);

        cleverapps.UI.fitToBox(this.name, {
            width: nameWidth,
            height: styles.name.height
        });

        this.nameWrapper.setContentSize2(nameWidth, styles.height);
        this.content.setOptions({ margin });
    },

    createPlace: function (place) {
        const styles = cleverapps.styles.RiddlesExpeditionFeastRowView;

        const placeNode = this.placeNode || new cc.Node();
        this.placeNode = placeNode;
        placeNode.setAnchorPoint(0.5, 0.5);

        placeNode.removeAllChildren();

        let content;
        const badgeIcon = bundles.expeditionfeast_window.frames[`badge_${place}`];
        if (this.options.badges && badgeIcon) {
            content = new cc.Sprite(badgeIcon);
        } else {
            const font = this.isPlayer() ? cleverapps.styles.FONTS.RIDDLES_EXPEDITIONFEAST_PLAYER_NUMBER_TEXT : cleverapps.styles.FONTS.RIDDLES_EXPEDITIONFEAST_ROW_NUMBER_TEXT;
            content = cleverapps.UI.generateImageText(this.row.data.notInTop ? "-" : place, font);
        }

        placeNode.setContentSize2(
            Math.max(
                this.options.badges && styles.place.withBadge.width || 0,
                styles.place.background ? styles.place.background.width : styles.place.width
            ),
            this.contentHeight
        );

        placeNode.addChild(content);
        content.setAlignment(placeNode.width / 2, placeNode.height / 2);

        return placeNode;
    },

    createFrame: function () {
        const frame = this.frame = new cc.Scale9Sprite(
            bundles.expeditionfeast_window.frames.row_you_frame_png,
            cleverapps.UI.getScale9Rect(
                bundles.expeditionfeast_window.frames.row_you_frame_png,
                cleverapps.UI.Scale9Rect.TwoPixelXY
            )
        );
        frame.setAnchorPoint(0.5, 0.5);
        this.addChild(frame, 1);
    },

    createAvatar: function () {
        return new cleverapps.UI.Avatar(this.row.data.avatar, {
            userId: this.row.id,
            frame: this.isPlayer() ? bundles.expeditionfeast_window.frames.table_avatar_frame2 : bundles.expeditionfeast_window.frames.table_avatar_frame,
            padding: cleverapps.styles.RiddlesExpeditionFeastRowView.avatar.padding
        });
    },

    createName: function () {
        const userName = this.row.data.name
            || typeof this.row.id === "string" && `Player_${this.row.id.substring(this.row.id.length - 3)}` || "";

        const font = this.isPlayer() ? cleverapps.styles.FONTS.RIDDLES_EXPEDITIONFEAST_PLAYER_TEXT : cleverapps.styles.FONTS.RIDDLES_EXPEDITIONFEAST_ROW_TEXT;
        return cleverapps.UI.generateOnlyText(userName, font);
    },

    createPrize: function () {
        if (!this.options.prizes) {
            return;
        }

        const styles = cleverapps.styles.RiddlesExpeditionFeastRowView;

        const width = styles.prize.width;

        const prizeNode = this.prizeNode || new cc.Node();
        this.prizeNode = prizeNode;
        prizeNode.setAnchorPoint(0.5, 0.5);
        prizeNode.removeAllChildren();
        cleverapps.tooltipManager.remove(prizeNode);

        prizeNode.setContentSize2(width, this.contentHeight);

        const prizeIcon = this.prizeIcon = this.row.data.prizeIcon;
        if (prizeIcon) {
            const prize = new cc.Sprite(prizeIcon);
            prizeNode.addChild(prize);
            prize.setAlignment({ x: { align: "center" }, y: { align: "center" } });

            cleverapps.tooltipManager.create(prizeNode, {
                rewards: this.row.data.prizeRewards,
                clickableArea: this.clickableArea
            });

            if (this.mode === cleverapps.WideMode.VERTICAL) {
                prize.setScale(0.65);
            }
        }

        return prizeNode;
    },

    createScore: function () {
        const styles = cleverapps.styles.RiddlesExpeditionFeastRowView.score;

        const image = this.isPlayer() ? bundles.expeditionfeast_window.frames.amount_bg_you_png : bundles.expeditionfeast_window.frames.amount_bg_png;
        const background = new cc.Scale9Sprite(image);

        let icon;

        if (this.options.dataIcon) {
            icon = this.scoreIcon = new cc.Sprite(this.options.dataIcon);
            icon.setAlignment(styles.icon);
            background.addChild(icon);
        }

        const font = cleverapps.styles.FONTS.RIDDLES_EXPEDITIONFEAST_ROW_SCORE_TEXT;
        const amount = this.scoreAmount = cleverapps.UI.generateImageText("222", font);

        background.addChild(amount);

        background.onResize = function () {
            background.setContentSize2(styles.width, styles.height);
            amount.setAlignment((background.width + (icon ? icon.x + icon.width / 4 : 0)) / 2, background.height / 2);
            amount.fitToSize = {
                width: (background.width - (icon ? icon.x + icon.width / 4 : 0)) * 0.8,
                height: background.height * 0.9
            };
            this.updateScore(this.row.score, { silent: true });
        }.bind(this);
        background.onResize();

        return background;
    },

    updatePlace: function (place) {
        if (this.place === place) {
            return;
        }
        this.place = place;

        this.createPlace(this.place);
        this.updateLocalZOrder();
    },

    updateLocalZOrder: function () {
        this.setLocalZOrder(this.isPlayer() ? 1000 : this.place);
    },

    updateScore: function (score, options) {
        options = options || {};

        if (!this.scoreAmount || this.score === score) {
            return;
        }

        this.score = score;

        this.scoreAmount.stopAllActions();
        this.scoreAmount.setString(this.score);
        this.scoreAmount.fitTo(this.scoreAmount.fitToSize.width, this.scoreAmount.fitToSize.height);

        if (options.silent) {
            return;
        }

        this.scoreAmount.runAction(new cc.Sequence(
            new cc.ScaleTo(0.2, 1.5),
            new cc.ScaleTo(0.2, 1)
        ));

        if (this.scoreIcon && this.options.dataIconAnimation && this.isPlayer()) {
            const animation = new cleverapps.Spine(this.options.dataIconAnimation);
            animation.setAnimation(0, "animation");
            animation.setLocalZOrder(100);
            this.addChild(animation);

            const updatePosition = function () {
                const parent = animation.parent;
                animation.setPosition(parent.convertToNodeSpace(this.scoreIcon.parent.convertToWorldSpace(this.scoreIcon.getPosition())));
                animation.setVisible(cc.rectContainsPoint(cc.rect(0, 0, parent.width, parent.height), animation.getPosition()));
            }.bind(this);

            animation.update = function (dt) {
                cleverapps.Spine.prototype.update.call(this, dt);
                updatePosition();
            }.bind(this);

            animation.scheduleUpdate();
            updatePosition();

            animation.replaceParentSamePlace(this.clickableArea, { keepScale: true });

            cleverapps.effects.fire(this.options.dataIconAnimationEffect);
        }
    },

    updatePrize: function () {
        if (!this.options.prizes || this.prizeIcon === this.row.data.prizeIcon) {
            return;
        }

        this.createPrize();
        this.prizeNode.runAction(new cc.Sequence(
            new cc.ScaleTo(0.2, 1.1),
            new cc.ScaleTo(0.2, 1)
        ));
    },

    updateRow: function (row) {
        this.row = row;

        this.updatePlace(this.row.data.place);
        this.updatePrize();
        this.updateScore(this.row.score);
    }
});

cleverapps.overrideColors(cleverapps.styles.COLORS, {
    RIDDLES_EXPEDITIONFEAST_ROW_VERTICAL_PLAYER_TEXT: new cc.Color(58, 96, 165, 255),
    RIDDLES_EXPEDITIONFEAST_ROW_NUMBER_PLAYER_COLOR: new cc.Color(18, 132, 132, 255),
    RIDDLES_EXPEDITIONFEAST_ROW_COLOR: new cc.Color(140, 65, 33, 255),
    RIDDLES_EXPEDITIONFEAST_ROW_PLAYER_COLOR: new cc.Color(18, 132, 132, 255)
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    RIDDLES_EXPEDITIONFEAST_ROW_SCORE_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.WHITE
    },
    RIDDLES_EXPEDITIONFEAST_ROW_NUMBER_TEXT: {
        name: "nostroke",
        size: 50,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },
    RIDDLES_EXPEDITIONFEAST_PLAYER_NUMBER_TEXT: {
        name: "nostroke",
        size: 50,
        color: cleverapps.styles.COLORS.RIDDLES_EXPEDITIONFEAST_ROW_NUMBER_PLAYER_COLOR
    },
    RIDDLES_EXPEDITIONFEAST_PLAYER_TEXT: {
        name: "lightstroke",
        size: 50,
        color: cleverapps.styles.COLORS.RIDDLES_EXPEDITIONFEAST_ROW_PLAYER_COLOR
    },
    RIDDLES_EXPEDITIONFEAST_ROW_TEXT: {
        name: "lightstroke",
        size: 50,
        color: cleverapps.styles.COLORS.RIDDLES_EXPEDITIONFEAST_ROW_COLOR
    }
});

cleverapps.styles.RiddlesExpeditionFeastRowView = {
    width: 1050,
    height: 138,

    minWidth: 700,
    scenePadding: [100, 250, 250],

    content: {
        height: 100,
        margin: 19,

        x: { align: "center" },
        y: { align: "center" },

        padding: {
            left: [10, 30, 30],
            right: [10, 30, 30]
        }
    },

    place: {
        withBadge: {
            width: 60
        },

        width: 50
    },

    name: {
        height: 80,

        position: [
            {
                x: { align: "left" },
                y: { align: "center", dy: 0 }
            },
            {
                x: { align: "left", dx: 0 },
                y: { align: "center", dy: 0 }
            },
            {
                x: { align: "left", dx: 0 },
                y: { align: "center", dy: 0 }
            }
        ]
    },

    avatar: {
        padding: {
            x: 0,
            top: 0,
            bottom: 0
        }
    },

    prize: {
        width: 160
    },

    score: {
        width: 170,
        height: 84,

        icon: [{
            x: 8,
            y: { align: "center", dy: -1 }
        }, {
            x: 15,
            y: { align: "center" }
        }, {
            x: 15,
            y: { align: "center" }
        }]
    }
};